import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { primaryImageStyles } from "@tIntermatic/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { css } from "styled-components";

primaryImageStyles.fullPrimaryImageModal = {
    cssOverrides: {
        scrim: css`
            height: 100% !important;
            overflow: auto;
            position: absolute !important;
            touch-action: auto;
        `,
        modalContainer: css`
            width: auto;
            > div {
                @media all and (max-width: 768px) and (min-width: 0px) {
                    min-width: 100%;
                }
                @media all and (max-width: 1024px) and (min-width: 768px) {
                    min-width: 80%;
                }
            }
        `,
        modalBody: css`
            width: auto;
            max-width: initial;
            max-height: auto !important;
            height: auto !important;
            box-shadow: 0 0 10px 0 rgb(0 0 0 / 0.15) !important;
            border: 1px solid #e5e5e5;
            background-color: #fff;
            position: absolute;
            top: 290px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            top: 1%;
                            margin: 0 auto;
                            min-width: 90% !important;
                            width: 90% !important;
                        `,
                        css`
                            top: 1%;
                            margin: 0 auto;
                            min-width: 90% !important;
                            width: 90% !important;
                        `,
                        css`
                            top: 1%;
                            margin: 0 auto;
                            min-width: 90% !important;
                            width: 90% !important;
                        `,
                        css`
                            top: 290px;
                            min-width: auto !important;
                            width: auto !important;
                        `,
                        css`
                            top: 290px;
                            min-width: auto !important;
                            width: auto !important;
                        `,
                    ],
                    "min",
                )}
        `,
        modalTitle: css`
            border-bottom: none;
            padding: 10px 10px 0;
        `,
        modalContent: css`
            text-align: center;
            display: flex;
            flex-direction: column;
            height: auto;
        `,
        titleButton: css`
            color: #363636 !important;
            border: none;
            padding: 0;
            > span {
                color: #363636 !important;
                height: 100%;
                width: 100%;
                > svg {
                    height: 38px;
                    width: 38px;
                    stroke-width: 1;
                    stroke: #363636;
                }
            }
            &:hover {
                background: none;
            }
        `,
    },
};